import { render, staticRenderFns } from "./VueFormIfSingularAttribute.vue?vue&type=template&id=7f2cfe86&scoped=true"
import script from "./VueFormIfSingularAttribute.vue?vue&type=script&lang=ts"
export * from "./VueFormIfSingularAttribute.vue?vue&type=script&lang=ts"
import style0 from "./VueFormIfSingularAttribute.vue?vue&type=style&index=0&id=7f2cfe86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2cfe86",
  null
  
)

export default component.exports